import { create } from 'zustand';
import { SuperAdminDataListFilterState } from '@/features/superAdmin/features/data/types/superAdmin-data.types';

const DEFAULT_PAGE_SIZE = 10;

const createDefaultFilter = (): SuperAdminDataListFilterState => ({
    take: DEFAULT_PAGE_SIZE,
    skip: 0,
    startDate: null,
    endDate: null,
    tenantId: null,
    tenantName: null,
    ownerId: null,
    ownerName: null,
    apartmentId: null,
    apartmentName: null,
    hotelId: null,
    hotelName: null,
    documentNumber: null,
    orderBy: null,
    orderDirection: 'desc',
});

type BookingsFilterStore = {
    filter: SuperAdminDataListFilterState;
    setFilter: (filter: Partial<SuperAdminDataListFilterState>) => void;
    resetFilter: () => void;
};

export const useSuperAdminBookingsFilter = create<BookingsFilterStore>((set) => ({
    filter: createDefaultFilter(),
    setFilter: (newFilter) => {
        set((state) => ({
            filter: {
                ...state.filter,
                ...newFilter,
            },
        }));
    },
    resetFilter: () => {
        set({ filter: createDefaultFilter() });
    },
}));
